export default "__VITE_ASSET__8YB0mvPn__"